import { render, staticRenderFns } from "./QNoticesAcknowledgeButtons.vue?vue&type=template&id=71f1a1e0&scoped=true&"
import script from "./QNoticesAcknowledgeButtons.vue?vue&type=script&lang=ts&"
export * from "./QNoticesAcknowledgeButtons.vue?vue&type=script&lang=ts&"
import style0 from "./QNoticesAcknowledgeButtons.vue?vue&type=style&index=0&id=71f1a1e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1a1e0",
  null
  
)

export default component.exports